import React, { useState, useEffect } from "react";
import { Form, Select, InputNumber, Typography } from "antd";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { elvis } from "../../Utils";
import Map2 from "../Map/Map2";

const { Option } = Select;
const { Title } = Typography;

const TlcServiceDamageForm = props => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [serviceOutageTypes, setServiceOutageTypes] = useState([]);

  const formItemLayout = {
    labelCol: {
      sm: { span: 8 }
    },
    wrapperCol: {
      sm: { span: 16 }
    }
  };

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_API_ENDPOINT + "/telecommunication/enums/service-outages")
      .then(({ data }) => {
        setServiceOutageTypes(data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (props.record.damage) {
      form.setFieldsValue({
        lossOfService: props.record.damage.lossOfService,
        affectedUsers: props.record.damage.affectedUsers,
        telecomOutage: props.record.damage.telecomOutage,
        geometry: props.record.damage.geometry,
      });
    }
  }, [props.record.damage, form]);

  const onValuesChange = (changedValues) => {
    form.validateFields(Object.keys(changedValues));
  };

  const onFieldsChange = (changedFields, allFields) => {
    const fieldsError = form.getFieldsError();
    var valid = fieldsError.every(field => !field.errors || field.errors.length === 0);
    
    const values = form.getFieldsValue();
    const newDamage = { ...props.record };
    newDamage.damage.lossOfService = elvis(values.lossOfService);
    newDamage.damage.affectedUsers = elvis(values.affectedUsers);
    newDamage.damage.telecomOutage = elvis(values.telecomOutage);
    newDamage.damage.geometry = elvis(values.geometry);
    newDamage.valid = valid;
    props.parentCallback(newDamage);
  };

  return (
    <Form 
      {...formItemLayout} 
      className="details_form"
      form={form}
      onValuesChange={onValuesChange}
      onFieldsChange={onFieldsChange}
      name="tlcServiceDamage"
    >
      <Title className="details_form_header"
        title="Damages details"
        subTitle="Network Service"
      />
      <Form.Item label="Loss of service (%)" name="lossOfService">
        <InputNumber />
      </Form.Item>
      <Form.Item label="Affected Users" name="affectedUsers">
        <InputNumber />
      </Form.Item>
      <Form.Item
        label="Outage category"
        name="telecomOutage"
        tooltip="Outage category"
      >
        <Select>
          {serviceOutageTypes.map(name => (
            <Option key={name} value={name}>
              {t('telecommunicationEnums.serviceOutage.' + name, name)}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item label="Affected Area" name="geometry">
        <Map2 name="affected_area"></Map2>
      </Form.Item>
    </Form>
  );
};

export default TlcServiceDamageForm;